<mat-icon color="primary" [class.open]="open">expand_more</mat-icon>